import type { TestDataProps } from "@repo/ui";
import clsx from "clsx";
import type React from "react";
import styles from "./VerticalStepper.module.css";

export type Step = {
  key: React.Key;
  title: string;
  titleContent?: React.ReactNode;
  content: React.ReactNode;
  disabled?: boolean;
};

type VerticalStepperProps = { steps: Step[] } & TestDataProps;

export const VerticalStepper = ({
  steps,
  "data-testid": testId,
}: VerticalStepperProps) => {
  return (
    <div className={clsx("ps-flex ps-flex-col")} data-testid={testId}>
      {steps.map(({ key, title, content, titleContent, disabled }, index) => (
        <div
          key={key}
          className={clsx("ps-flex ps-gap-8")}
          data-testid={`${testId}-${key}-step`}
          aria-disabled={disabled}
        >
          <div className={clsx("ps-flex ps-flex-col")}>
            <div
              className={clsx(styles.stepNumber, disabled && styles.disabled)}
            >
              <span data-testid={`${testId}-${key}-step-indicator`}>
                {index + 1}
              </span>
            </div>
            {index < steps.length - 1 && (
              <div className={styles.stepIndicator} />
            )}
          </div>
          <div className={clsx("ps-flex ps-flex-col ps-flex-1")}>
            <div
              data-testid={`${testId}-${key}-step-title`}
              className={clsx(
                styles.stepTitle,
                disabled && styles.disabled,
                "ps-flex ps-gap-2 ps-items-center"
              )}
            >
              {title}
              {titleContent}
            </div>
            <div data-testid={`${testId}-${key}-step-content`}>{content}</div>
          </div>
        </div>
      ))}
    </div>
  );
};
